import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/interface/store';
import { GrantData, ManageGroup } from '@/interface/store/manageGroups';

export const initialState = () => {
  return {
    meData: {
      id: '',
      email: '',
      isAdmin: false,
      status: '',
      createdAt: '',
      fkUser: {
        id: '',
        fullName: '',
        fkUserAvatars: null,
      },
    },
    fkUserMemberships: [],
    memberList: [],
    mainLocationList: [],
    subLocationList: [],
    subLocationName: '',
    typeList: [],
    typeFieldList: [],
    typeFieldItem: {
      id: '',
      name: '',
      format: '',
      acceptedValues: {},
      isRequired: false,
      fkTypeId: '',
    },
    vendorList: [],
    vendorItem: {
      id: '',
      name: '',
      url: null,
      contactName: null,
      contactPhone: null,
      contactEmail: null,
      info: null,
      fkGroupId: '',
    },
    manufacturerList: [],
    manufacturerItem: {
      id: '',
      name: '',
      url: null,
      contactName: null,
      contactPhone: null,
      contactEmail: null,
      info: null,
      fkGroupId: '',
    },
    addressList: [],
    addressItem: {
      organization: '',
      name: '',
      address: '',
      detailAddress: '',
      zip: '',
      phoneNumber1: '',
      phoneNumber2: '',
      city: '',
      state: '',
      isActive: false,
      verified: false,
    },
    grantList: [],
    grantItem: {
      id: '',
      name: '',
      isDisabled: false,
    },
    settings: {
      id: '',
      accountNumber: '',
      name: '',
      organization: '',
      description: null,
      isPrivate: false,
      creditExpiration: null,
      fkGroupMemberships: [],
      settings: {
        taxRate: 0,
        currency: '',
        timezone: '',
        orderSteps: '',
        paymentMode: '',
        inventoryEdit: '',
        membershipPolicy: '',
      },
      credit: {
        amount: false,
        creditCurrency: false,
      },
    },
  };
};

export const state: ManageGroup = initialState();

const namespaced: boolean = true;

export const manageGroup: Module<ManageGroup, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
